import { Ident } from '@mode-switch/express';
import { Query } from './Query';
export var ExportPlan;
(function (ExportPlan) {
    function make(model, viewName, query, options = {
        type: 'csv',
        headers: true,
    }) {
        const { fields: field, sorts: sort, filters: filter, limit, offset, } = query;
        const id = Ident.next();
        const page = {
            id,
            model,
            viewName,
            queries: [
                Query.Table.make({
                    name: 'records',
                    fields: field,
                    sorts: sort,
                    filters: filter,
                    limit,
                    offset,
                }),
            ],
            type: "EXPORT",
            format: {
                type: options.type,
                options: {
                    headers: options.headers,
                },
            },
        };
        return page;
    }
    ExportPlan.make = make;
})(ExportPlan || (ExportPlan = {}));
